import { RestClientV5 } from "bybit-api";
import { useState, useEffect } from "react";

const bybitAPI = new RestClientV5({
  syncTimeBeforePrivateRequests: true,
});

export const useByBitAPI = (): RestClientV5 => {
  return bybitAPI;
};

export const useAPIRequest = <T>(
  callback: () => Promise<T>,
): { isLoading: boolean; data?: T; error?: Error } => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<T | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    setIsLoading(true);
    callback()
      .then((result) => {
        setData(result);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [callback]);

  return { isLoading, data, error };
};
